import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type UnarchiveAccountLocationMutationVariables = GraphQLTypes.Exact<{
  locationId: GraphQLTypes.Scalars['String']['input'];
}>;

export type UnarchiveAccountLocationMutationResult = { __typename?: 'Mutation' } & {
  unarchiveAccountLocation?: GraphQLTypes.Maybe<
    { __typename?: 'UnarchiveAccountLocationPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'path'>>>;
    }
  >;
};

export const UnarchiveAccountLocationDocument = gql`
  mutation unarchiveAccountLocation($locationId: String!) {
    unarchiveAccountLocation(locationId: $locationId) {
      errors {
        path
      }
    }
  }
`;
